module.exports = __webpack_public_path__ + "img/t-3.3e66242.png";